/**
 * Product image helpers — per-file object-fit / position overrides plus
 * gallery generation. Extracted from ProductDetailPage.jsx in the Feb
 * 2026 P2 refactor so the same rules can be reused by the Product
 * Comparison page and any future gallery consumer without importing
 * the full 1300-line component.
 */

/**
 * When a product's marketing photo has to be shown edge-to-edge, cropping
 * is fine — but some hero shots (lobby wides, install shots) look wrong
 * cropped. Explicitly opt those images into ``object-contain``.
 */
export const objectFitOverrides = {
  '/Assets/images/products/spectra-print/Spectra_LobbyHotel.jpg': 'contain',
  '/Assets/images/products/kensington-tile/kensington_install.jpg': 'contain',
  '/Assets/images/products/18x36-lvt/gallery/reception_concrete.jpg': 'contain',
};

/**
 * When ``object-cover`` is used, browsers default to center-cropping. A
 * few hero images have their subject at the bottom edge — force the
 * position so we don't crop off the interesting part.
 */
export const imagePositionOverrides = {
  '/Assets/images/products/100-series/100series_spinning.jpg': 'bottom',
  '/Assets/images/products/18x36-lvt/gallery/office_openspace.jpg': 'bottom',
};

/**
 * Return the list of gallery images for a product. Prefers an explicit
 * ``product.gallery`` array; falls back to ``heroImage`` or the primary
 * ``image`` so single-photo products still render a valid gallery.
 */
export const generateGallery = (product) => {
  if (product.gallery && product.gallery.length > 0) {
    return product.gallery;
  }
  const gallery = [];
  if (product.heroImage) {
    gallery.push(product.heroImage);
  } else {
    gallery.push(product.image);
  }
  return gallery;
};
